import { gql } from '@apollo/client'
import { pathOr } from 'ramda'
import React from 'react'

import { triggersClient } from '../../../utils/apollo/api'
import { usePromiseQuery } from '../../../utils/apollo/_helpers/promiseQuery'
import { useSaveFolder } from './_request/saveFolder'
import Select from '../../../packages/kiti/components/form/Select'

const QUERY = gql`
  query Folders($search: String, $page: Int) {
    folders(search: $search, page: $page, sort: { field: NAME, type: ASC }) {
      id
      name
    }
  }
`

const useFolderLoader = () => {
  const query = usePromiseQuery(QUERY, { client: triggersClient })

  return (search, page = 1) => {
    return query({ search, page })?.then(pathOr([], ['data', 'folders']))
  }
}

const FolderSelect = ({ onChange, value, ...props }) => {
  const getOptions = useFolderLoader()
  const [create] = useSaveFolder(onChange)

  return (
    <Select
      value={value} //
      onChange={onChange}
      options={getOptions}
      onCreate={create}
      {...props}
    />
  )
}

export default FolderSelect
